<template>
  <section class="card-container">
    <slot v-if="state.displayedAnnuaire.length > 0">
      <div class="card" v-for="(pro, index) in state.displayedAnnuaire" :key="index">
        <div class="header">
          <div class="overview">
            <div v-if="pro.image_profil !== null" class="picture">
              <a @click="goToProfil(pro.id)" target="_blank" style="cursor: pointer">
                <img style="max-width: 80px; height: auto;" :src="pro.image_profil.url_fichier" alt="img-profil"/>
              </a>
            </div>
            <div class="info">
              <a
                  class="color-text"
                  style="font-size: 20px; font-weight: bold; margin-top: 0; cursor: pointer"
                  @click="goToProfil(pro.id)"
                  target="_blank"
              >{{ pro.user?.display_name }}</a>
              <p style="display: flex; align-items: center">
                <IconLocation width="20px" height="20px"></IconLocation>
                {{ pro.adresse_cabinet + " " + pro.code_postal_cabinet + " " + pro.ville_cabinet }}
              </p>
            </div>
          </div>
          <div class="additionnal-info">
            <ul>
              <li>
                <IconPeople width="20px" height="20px"></IconPeople>
                <span v-if="pro.accompagnement_tous_public == 1">Tous public</span>
                <p v-else>
                  <span v-if="pro.accompagnement_couple == 1">Couples</span>
                  <span
                      v-if="pro.accompagnement_couple == 1 && pro.accompagnement_enfant == 1"
                  >&nbsp|&nbsp</span>
                  <span v-if="pro.accompagnement_enfant == 1">Enfants</span>
                </p>
              </li>
              <li>
                <IconHome width="20px" height="20px"></IconHome>
                <span
                    v-if="pro.distanciel == 1 && pro.presentiel == 1"
                >En cabinet / à distance</span>
                <span v-if="pro.distanciel == 1 && pro.presentiel == 0">A distance</span>
                <span v-if="pro.presentiel == 1 && pro.distanciel == 0">En cabinet</span>
              </li>
              <li v-if="pro.tarif_minimum">
                <IconLocalOffer width="20px" height="20px"></IconLocalOffer>
                <span>Tarif à partir de: {{ pro.tarif_minimum }} €</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="contact">
          <div class="links">
            <div>
              <IconEmail width="20px" height="20px"></IconEmail>
              <a :href="'mailto:' + pro.email">{{ pro.email }}</a>
            </div>

            <div v-if="pro.publication_numero == 1">
              <IconPhone width="20px" height="20px"></IconPhone>
              <a :href="'tel+33' + pro.tel">{{ pro.tel }}</a>
            </div>

            <div v-if="pro.page_facebook !== null">
              <IconFacebook width="20px" height="20px"></IconFacebook>
              <a target="_blank" :href="pro.page_facebook">Facebook</a>
            </div>

            <div v-if="pro.page_instagram !== null">
              <IconInstagram width="20px" height="20px"></IconInstagram>
              <a target="_blank" :href="pro.page_instagram">Instagram</a>
            </div>
          </div>

          <div style="display: flex; align-items: center; justify-content: center;">
            <div>
              <button style="padding: 0.25rem; " @click="goToProfil(pro.id)">
                Voir profil
                <IconVisibility width="20px" height="20px" color="white"></IconVisibility>
              </button>
            </div>
            <div v-if="pro.site_internet !== null">
              <button
                  style="padding: 0.25rem; margin-left: 0.5rem"
                  @click="makeAppointment(pro.site_internet)"
              >
                Prendre rendez-vous
                <IconOpenInNew width="20px" height="20px" color="white"></IconOpenInNew>
              </button>
            </div>
          </div>
        </div>
      </div>
    </slot>
    <slot v-else>
      <div class="no-result">
        <p>Aucun praticiens découverts</p>
      </div>
    </slot>
  </section>
</template>

<script>
import {state, wpApiSettings} from "../store";
import IconLocation from "./Icons/IconLocation.vue";
import IconPeople from "./Icons/IconPeople.vue";
import IconHome from "./Icons/IconHome.vue";
import IconLocalOffer from "./Icons/IconLocalOffer.vue";
import IconEmail from "./Icons/IconEmail.vue";
import IconPhone from "./Icons/IconPhone.vue";
import IconFacebook from "./Icons/IconFacebook.vue";
import IconInstagram from "./Icons/IconInstagram.vue";
import IconVisibility from "./Icons/IconVisibility.vue";
import IconOpenInNew from "./Icons/IconOpenInNew.vue";

export default {
  name: "ProCard",
  setup() {
    const makeAppointment = (url) => {
      window.open(url, '_blank');
    }

    const goToProfil = (id) => {
      window.open(`${wpApiSettings.url}/suph/profil?id=${id}`, '_blank');
    }

    return {state, goToProfil, makeAppointment};
  },
  components: {
    IconLocation,
    IconPeople,
    IconHome,
    IconLocalOffer,
    IconEmail,
    IconPhone,
    IconFacebook,
    IconInstagram,
    IconVisibility,
    IconOpenInNew
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/_variables.scss";

.no-result {
  text-align: center;

  p {
    padding: 1em;
    margin: 0;
  }
}

.card-container {
  .logo {
    width: 20px;
    height: 20px;
    vertical-align: bottom;
  }

  .card {
    border-bottom: 1px solid rgba(0, 0, 0, 0.35);
    padding: 1em;
    border-radius: 5px;

    .header {
      display: flex;

      > div {
        width: 50%;
      }

      .overview {
        display: flex;
        align-items: center;

        .picture {
          img {
            border-radius: 50%;
            height: 120px;
            width: 120px;
            margin-right: 1em;
          }
        }
      }

      .additionnal-info {
        ul {
          margin: 0;
          padding: 0;

          li {
            list-style-type: none;
            display: flex;
            align-items: center;

            span {
              padding-left: 0.5rem;
            }
          }
        }
      }
    }

    .color-text {
      color: $base-color;
    }

    .contact {
      @include buttonStyle($base-color, 1px solid $base-color, white);
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 1rem;

      .links {
        display: flex;

        > div {
          margin: 0 0.5rem;
          display: flex;
          align-items: center;

          a {
            padding: 0 0.25rem;
          }
        }
      }
    }
  }
}
</style>